export default "__VITE_ASSET__C10O0oiE__"